var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('defaultnavbar',{attrs:{"login":_vm.login,"user":_vm.user,"notificationCount":_vm.notificationCount}}),_vm._v(" "),_c('div',{staticClass:"ib-main-box"},[_c('router-view')],1),_vm._v(" "),_c('defaultfooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46a6dfe8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/default.vue
// module id = null
// module chunks = 